export default __webpack_public_path__ + "static/media/more-one.25dd907a.svg";